import React from "react";

import Topbar from "../../components/topbar";
import Tabs from "../../components/ui/tabs";
import { Autocomplete, Avatar, Box, Button, Paper, TextField, Typography } from "@mui/material";

type TabKey = "profile" | "password";

const AdminProfile: React.FC = () => {
    const [activeTab, setActiveTab] = React.useState<TabKey>("profile");

    const render: Record<TabKey, React.ReactNode> = {
        profile: <ProfileSettings />,
        password: <ChangePassword />,
    }

    return (
        <div style={{ width: '100%' }}>
            <Topbar title="Profile"/>
            <div style={{ padding: '10px', background: 'var(--color-page-background)', height: 'calc(100vh - 86px)' }}>
                <Paper sx={{ p: 3, borderRadius: 2}}>
                    <Tabs
                        tabs={[
                            { label: "Profile", key: "profile" },
                            { label: "Change Password", key: "password" },
                        ]}
                        activeKey={activeTab}
                        onChange={(key) => setActiveTab(key as TabKey)}
                    />
                    {render[activeTab]}
                </Paper>
            </div>
        </div>
    );
};

const ProfileSettings: React.FC = () => {
    return (
        <React.Fragment>
        <Box display="flex" alignItems="center" justifyContent="space-between" my={4} maxWidth={1000}>
            <Box display="flex" alignItems="center" gap={2}>
                <Avatar src="/avatar1.png" sx={{ width: 64, height: 64 }} />
                <Box>
                    <Typography fontWeight={600} fontSize={18}>Alexa Rowles</Typography>
                    <Typography color="var(--color-text-muted)" fontSize={15}>alexarowles@gmail.com</Typography>
                </Box>
            </Box>
            <Button variant="contained" sx={{ bgcolor: 'var(--color-primary)', color: '#fff', borderRadius: 2, px: 4, fontWeight: 600, textTransform: 'none' }}>Edit</Button>
        </Box>
        <Box display="flex" gap={4} maxWidth={1000}>
            <Box flex={1} display="flex" flexDirection="column" gap={3}>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>First Name</Typography>
                    <TextField placeholder="Your First Name" fullWidth size="small" />
                </Box>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>Gender</Typography>
                    <Autocomplete
                        options={[
                            { value: 'male', label: 'Male' },
                            { value: 'female', label: 'Female' },
                        ]}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select..." size="small" />
                        )}
                        sx={{ width: '100%', '& .MuiInputBase-root': { fontSize: 16 } }}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={null}
                        onChange={() => {}}
                    />
                </Box>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>Location</Typography>
                    <Autocomplete
                        options={[
                            { value: 'sydney', label: 'Sydney, Australia' },
                            { value: 'melbourne', label: 'Melbourne, Australia' },
                            { value: 'newyork', label: 'New York, USA' },
                            { value: 'london', label: 'London, UK' },
                        ]}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select..." size="small" />
                        )}
                        sx={{ width: '100%', '& .MuiInputBase-root': { fontSize: 16 } }}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={null}
                        onChange={() => {}}
                    />
                </Box>
            </Box>
            <Box flex={1} display="flex" flexDirection="column" gap={3} pb={5}>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>
                        Last Name
                    </Typography>
                    <TextField placeholder="Your Last Name" fullWidth size="small" />
                </Box>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>Country</Typography>
                    <Autocomplete
                        options={[
                            { value: 'australia', label: 'Australia' },
                            { value: 'usa', label: 'USA' },
                            { value: 'uk', label: 'UK' },
                            { value: 'canada', label: 'Canada' },
                        ]}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select..." size="small" />
                        )}
                        sx={{ width: '100%', '& .MuiInputBase-root': { fontSize: 16 } }}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={null}
                        onChange={() => {}}
                    />
                </Box>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>
                        Login Method
                    </Typography>
                    <TextField placeholder="Alexa Rowles" fullWidth size="small" disabled />
                </Box>
            </Box>
        </Box>
        </React.Fragment>
    );
};

const ChangePassword: React.FC = () => {
    return (
        <React.Fragment>.
            <Box flex={1} display="flex" flexDirection="column" gap={3} maxWidth={500} pb={5}>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>Current Password</Typography>
                    <TextField placeholder="Your Current Password" fullWidth size="small" />
                </Box>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>New Password</Typography>
                    <TextField placeholder="Your New Password" fullWidth size="small" />
                </Box>
                <Box>
                    <Typography fontWeight={500} fontSize={14} mb={0.5}>Confirm Password</Typography>
                    <TextField placeholder="Confirm Your New Password" fullWidth size="small" />
                </Box>
                <Button variant="contained" sx={{ bgcolor: 'var(--color-primary)', color: '#fff', borderRadius: 2, px: 4, fontWeight: 600, textTransform: 'none', maxWidth: 200 }}>Save</Button>
            </Box>
        </React.Fragment>
    );
}

export default AdminProfile;